import jqueryScript from "./assets/plugins/js/jquery-3.7.1.min.js?url";
import fancyboxScript from "./assets/plugins/js/fancybox.min.js?url";
import slickScript from "./assets/plugins/js/slick.min.js?url";

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`);
        if (existingScript) {
            if (
                existingScript.readyState === "complete" ||
                existingScript.readyState === "loaded"
            ) {
                resolve();
                return;
            }
        }

        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        document.head.appendChild(script);
    });
}

Promise.resolve()
    .then(() => loadScript(jqueryScript))
    .then(() => {
        return new Promise((resolve) => {
            const checkJQuery = () => {
                if (window.$ && window.jQuery) {
                    resolve();
                } else {
                    setTimeout(checkJQuery, 10);
                }
            };
            checkJQuery();
        });
    })
    .then(() => {
        return Promise.all([
            loadScript(fancyboxScript),
            loadScript(slickScript),
        ]);
    })
    .then(() => {
        initializeApp();
    });

import initForms from "./assets/js/form";
import initModals from "./assets/js/modal";
import initMenu from "./assets/js/menu";
import initSlick from "./assets/js/slick";
import initFancybox from "./assets/js/fancybox";
import initBannerAnimation from "./assets/js/banner-animation";

function mascaraTelefone(event) {
    let tecla = event.key;
    let telefone = event.target.value.replace(/\D+/g, "");

    if (/^[0-9]$/i.test(tecla)) {
        telefone = telefone + tecla;
        let tamanho = telefone.length;

        if (tamanho >= 12) {
            return false;
        }

        if (tamanho > 10) {
            telefone = telefone.replace(
                /^(\d\d)(\d{5})(\d{4}).*/,
                "($1) $2-$3"
            );
        } else if (tamanho > 5) {
            telefone = telefone.replace(
                /^(\d\d)(\d{4})(\d{0,4}).*/,
                "($1) $2-$3"
            );
        } else if (tamanho > 2) {
            telefone = telefone.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else {
            telefone = telefone.replace(/^(\d*)/, "($1");
        }

        event.target.value = telefone;
    }

    if (!["Backspace", "Delete"].includes(tecla)) {
        return false;
    }
}

window.mascaraTelefone = mascaraTelefone;

function initializeApp() {
    $(document).ready(function () {
        $(".tab-links a").on("click", function (e) {
            e.preventDefault();
            var currentAttrValue = $(this).attr("href");

            $(this)
                .parent("li")
                .addClass("active")
                .siblings()
                .removeClass("active");
            $(".tab" + currentAttrValue)
                .addClass("active")
                .siblings()
                .removeClass("active");
        });

        $(
            ".tab-links-obras a, .tab-links-mobile a, .tab-content-obras .tab-obras"
        ).on("click", function (e) {
            e.preventDefault();
            pauseAllVideos();

            const id = $(this).attr("id");
            const currentAttrValue = $(this).attr("href") || "#" + id;

            const carouselItem = $(this).closest(".slider-obras .item");

            const getActive = $(this)
                .parent()
                .parent()
                .find("li.active a")
                .attr("href");

            if (currentAttrValue === getActive) return;

            carouselItem
                .find(".tab-obras" + currentAttrValue)
                .addClass("active")
                .siblings()
                .removeClass("active");

            if (currentAttrValue.includes("#")) {
                $(this)
                    .parent("li")
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
            }

            if (id) {
                carouselItem
                    .find(".item-tab[href='#" + id + "']")
                    .parent("li")
                    .addClass("active")
                    .siblings()
                    .removeClass("active");
            }

            var refreshInterval = setInterval(function () {
                $(".slider-obras-fotos").slick("refresh");
                $(".slider-obras-videos").slick("refresh");
            }, 16);

            setTimeout(function () {
                clearInterval(refreshInterval);
                $(".slider-obras-fotos").slick("refresh");
                $(".slider-obras-videos").slick("refresh");
            }, 200);
        });

        $(".tab-wellness .tab-links li a").on("click", function (e) {
            e.preventDefault();

            const currentAttrValue = $(this).attr("href");

            if (currentAttrValue === "#terreo") {
                $(".slider-galeria-lazer-terreo").slick("refresh");
                $(".slider-galeria-lazer-sexto-pavimento").slick(
                    "slickGoTo",
                    0
                );
            } else if (currentAttrValue === "#sexto-pavimento") {
                $(".slider-galeria-lazer-sexto-pavimento").slick("refresh");
                $(".slider-galeria-lazer-terreo").slick("slickGoTo", 0);
            }
        });

        initFancybox();

        initSlick();

        initForms();

        initModals();

        initMenu();

        initBannerAnimation();

        initStickyBoxSocial();

        initVideoControls();

        initVistaImageSwitcher();
    });
}

function initStickyBoxSocial() {
    const boxSocial = $(".box-social");
    const contatoSection = $("footer");

    if (boxSocial.length && contatoSection.length) {
        let ticking = false;
        let currentState = "visible";

        function updateBoxVisibility() {
            const scrollTop = $(window).scrollTop();
            const windowHeight = $(window).height();
            const contatoOffset = contatoSection.offset().top;

            const hidePoint = contatoOffset - windowHeight + 100;

            if (scrollTop >= hidePoint && currentState !== "hidden") {
                currentState = "hidden";
                boxSocial.css({
                    opacity: "0",
                    "pointer-events": "none",
                });
            } else if (scrollTop < hidePoint && currentState !== "visible") {
                currentState = "visible";
                boxSocial.css({
                    opacity: "1",
                    "pointer-events": "auto",
                });
            }

            ticking = false;
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(updateBoxVisibility);
                ticking = true;
            }
        }

        $(window).on("scroll", requestTick);
        $(window).on("resize", function () {
            currentState = "";
            requestTick();
        });
    }
}

function pauseAllVideos() {
    $(".video-container video").each(function () {
        this.pause();
        this.controls = false;
        $(this).closest(".video-container").removeClass("playing");
    });
}

function initVideoControls() {
    $(".video-container").on("click", function (e) {
        e.preventDefault();

        const activeTab = $(".tab-obras.active").attr("id").includes("videos");

        if (!activeTab) {
            return;
        }

        e.stopPropagation();

        const video = $(this).find("video")[0];
        const container = $(this);

        if (video) {
            if (video.paused) {
                pauseAllVideos();

                video.volume = 1.0;
                video.controls = true;

                video
                    .play()
                    .then(() => {
                        container.addClass("playing");
                    })
                    .catch((e) => {
                        console.log("Erro ao reproduzir vídeo:", e);
                    });
            } else {
                video.pause();
                video.controls = false;
                container.removeClass("playing");
            }
        }
    });

    $(".video-container video").on("play", function () {
        $(this).closest(".video-container").addClass("playing");
        this.controls = true;
    });

    $(".video-container video").on("pause", function () {
        $(this).closest(".video-container").removeClass("playing");
        this.controls = false;
    });

    $(".video-container video").on("ended", function () {
        $(this).closest(".video-container").removeClass("playing");
        this.controls = false;
    });

    $(".slider-obras").on("afterChange", function (event, slick, currentSlide) {
        pauseAllVideos();
    });
}

function initVistaImageSwitcher() {
    const vistaButtons = document.querySelectorAll(
        "#vistas button[data-vista], #vistas .btn-tab-mobile[data-vista]"
    );
    const vistaImages = document.querySelectorAll("#vistas .vista-img");

    vistaButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const vistaType = this.getAttribute("data-vista");

            vistaButtons.forEach((btn) => {
                btn.classList.remove("active");
            });

            vistaImages.forEach((img) => {
                img.classList.remove("active");
            });

            this.classList.add("active");

            const targetImage = document.querySelector(
                `#vistas .vista-img[data-vista="${vistaType}"]`
            );

            if (targetImage) {
                targetImage.classList.add("active");

                const allTexts = document.querySelectorAll(
                    `#vistas .texto-mobile`
                );

                if (allTexts.length > 0) {
                    allTexts.forEach((text) => {
                        text.classList.remove("active");
                    });

                    const targetText = document.querySelector(
                        `#vistas .texto-mobile[data-vista="${vistaType}"]`
                    );

                    if (targetText) {
                        targetText.classList.add("active");
                    }
                }
            }
        });
    });
}
